module.exports = __webpack_public_path__ + "c89246a79d7bea5ed93a03ee3d37b744.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau04.jpg
// module id = 660
// module chunks = 0